"use strict";

exports.__esModule = true;
var _TextAlignmentPicker = require("./TextAlignmentPicker");
Object.keys(_TextAlignmentPicker).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TextAlignmentPicker[key]) return;
  exports[key] = _TextAlignmentPicker[key];
});